import { Check } from './../../../../components/visit-overview/dialog/register-entrance/model/Check';
import { Component, Input } from '@angular/core';
import { TranslationService } from '@sdbn/common';

@Component({
    selector: 'app-hints',
    templateUrl: './hints.component.html',
    styleUrls: ['./hints.component.scss'],
    standalone: false
})
export class HintsComponent {

  @Input() checks: Array<Check>;

  constructor(public translationService: TranslationService) { }

  getIconForState(state: string): string {
    switch (state) {
      case 'OK':
        return 'fa-check-circle';
      case 'FAILED':
        return 'fa-triangle-exclamation';
      case 'WARN':
        return 'fa-circle-exclamation';
      case 'INFO':
        return 'fa-circle-info';
    }
    return null;
  }

}
